<template>
    <div class="col-md-3 left_col no-print" :class="{ isStudent: auth.user().role == 'Student' }">
        <div v-if="showToggle" class="left_col">
            <div class="menu-logo-wrapper flexOnly align-items justifyCenter hidden-xs hidden-sm">
                <img src="/img/icons/_newicons_intedashboardlogo.png" width="25" alt="InteDashboard | TBL Makes Teams Work" />
            </div>
            <nav id="sidebar-menu" class="main_menu_side hidden-print main_menu menu_fixed" aria-label="Main Sidebar">
                <ul class="nav side-menu getSideMenuHeight">
                    <li v-if="auth.user().role == 'Superuser'">
                        <router-link
                            tag="a"
                            :to="{ name: 'accounts.index' }"
                            :class="{ active: $route.name?.startsWith('accounts.') }"
                            aria-labelledby="Accounts"
                        >
                            <div class="textAlignCenter">
                                <i class="fa fa-id-card" aria-hidden="true"></i>
                                <p>{{ $t('modules.accounts.moduleLabel') }}</p>
                            </div>
                        </router-link>
                    </li>

                    <li v-if="auth.user().role == 'Superuser'">
                        <router-link
                            tag="a"
                            :to="{ name: 'superusers.index' }"
                            :class="{ active: $route.name?.startsWith('superusers.') }"
                            aria-labelledby="Superuser"
                        >
                            <div class="menu-container textAlignCenter">
                                <i class="fas fa-crown" aria-hidden="true"></i>
                                <p>{{ $t('modules.superusers.moduleLabel') }}</p>
                            </div>
                        </router-link>
                    </li>

                    <li v-if="auth.user().role == 'Teacher' || auth.user().role == 'Super Admin'">
                        <router-link
                            tag="a"
                            :to="{ name: 'courses.index' }"
                            :class="{ active: $route.name?.startsWith('courses.') || $route.name == 'activities.tests.dashboard' }"
                            aria-labelledby="Courses"
                        >
                            <div class="menu-container textAlignCenter">
                                <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                                <p>Courses</p>
                            </div>
                        </router-link>
                    </li>

                    <li v-if="auth.user().role == 'Super Admin' || auth.user().role == 'Teacher'">
                        <router-link
                            tag="a"
                            :to="{ name: 'people.index' }"
                            :class="{
                                active:
                                    $route.name?.startsWith('people.') || $route.name?.startsWith('teachers.view') || $route.name?.startsWith('students.view'),
                            }"
                            aria-labelledby="Teachers"
                        >
                            <div class="menu-container textAlignCenter">
                                <i class="fa fa-users" aria-hidden="true"></i>
                                <p>People</p>
                            </div>
                        </router-link>
                    </li>
                    <li
                        v-if="
                            (auth.user().role == 'Teacher' || auth.user().role == 'Super Admin') &&
                            auth.user().account.version == 'full' &&
                            !(auth.user().canViewQuestionBank == false)
                        "
                    >
                        <router-link tag="a" :to="{ name: 'questions.index' }" aria-labelledby="Library">
                            <div class="menu-container textAlignCenter">
                                <i class="fa fa-list-ul" aria-hidden="true"></i>
                                <p>Library</p>
                            </div>
                        </router-link>
                    </li>

                    <li v-if="auth.user().role == 'Student'">
                        <router-link tag="a" :to="{ name: 'tests.index' }">
                            <div class="menu-container textAlignCenter" aria-labelledby="Activities">
                                <i class="fas fa-pencil-ruler" aria-hidden="true"></i>
                                <p>Activities</p>
                            </div>
                        </router-link>
                    </li>

                    <li v-if="auth.user().role == 'Student'">
                        <router-link tag="a" :to="{ name: 'grades.index' }">
                            <div class="menu-container textAlignCenter" aria-labelledby="Grades">
                                <i class="fa fa-book" aria-hidden="true"></i>
                                <p>Gradebook</p>
                            </div>
                        </router-link>
                    </li>

                    <li v-if="auth.user().role == 'Superuser'">
                        <router-link tag="a" :to="{ name: 'report' }" aria-labelledby="Report">
                            <div class="menu-container textAlignCenter">
                                <i class="fas fa-file-alt" aria-hidden="true"></i>
                                <p>{{ $t('modules.reports.moduleLabel') }}</p>
                            </div>
                        </router-link>
                    </li>

                    <li v-if="auth.user().role == 'Super Admin'">
                        <router-link tag="a" :to="{ name: 'settings.edit' }" aria-labelledby="Report">
                            <div class="menu-container textAlignCenter">
                                <i class="fa fa-wrench" aria-hidden="true"></i>
                                <p>Settings</p>
                            </div>
                        </router-link>
                    </li>

                    <li v-if="auth.user().roleId == 2 || auth.user().roleId == 3">
                        <a href="https://community.intedashboard.com/" target="_blank">
                            <div class="menu-container textAlignCenter">
                                <span class="material-icons" aria-hidden="true"> forum </span>
                                <p>Community</p>
                            </div>
                        </a>
                    </li>

                    <li v-if="auth.user().role == 'Super Admin'">
                        <a
                            :href="`https://v3.intedashboard.com/launchexternal?url=https://modernreportcard.retool.com/embedded/public/917e77cc-2b71-4f40-afd4-aadd5bb1b10a&name=${
                                auth.user().displayName
                            }`"
                            target="_blank"
                        >
                            <div class="menu-container textAlignCenter">
                                <span class="material-icons" aria-hidden="true"> analytics </span>
                                <p>Analytics</p>
                                <span class="badge badge-pill badge-info betaBadge"> BETA </span>
                            </div>
                        </a>
                    </li>

                    <!-- <li>
                        <router-link tag="a" :to="{ name: 'announcement.index' }">
                            <div class="menu-container textAlignCenter" aria-labelledby="Announcement">
                                <div class="icon-container">
                                    <i class="fa fa-bullhorn" aria-hidden="true"></i>
                                    <span v-if="!isAnnouncementViewed()" class="red-dot">New</span>
                                </div>
                                <p>Announcement</p>
                            </div>
                        </router-link>
                    </li> -->
                </ul>

                <ul class="nav side-menu help-center">
                    <li>
                        <a
                            :href="
                                auth.user().role == 'Student'
                                    ? 'https://help.intedashboard.com/learner'
                                    : 'https://help.intedashboard.com/contact-intedashboard-support'
                            "
                            target="_blank"
                        >
                            <div class="menu-container textAlignCenter">
                                <i class="fas fa-question-circle" aria-hidden="true"></i>
                                <p>Help</p>
                            </div>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>
<script setup>
import KrAuth from '../../../../components/auth/auth.js';
import swal from 'sweetalert2';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const auth = new KrAuth();
const showToggle = ref(false);

const isAnnouncementViewed = () => {
    const pageKey = `page_viewed_/in/announcement`;
    return localStorage.getItem(pageKey) === 'true';
};

onMounted(() => {
    if (route.name == 'tests.preview') {
        showToggle.value = false;
    } else {
        showToggle.value = true;
    }
});
</script>
<style scoped lang="scss">
.nav.side-menu {
    background: #495060;
    overflow-y: auto;

    & > li a {
        padding: 12px 8px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 6px solid transparent;
        color: #ffffff;
        background: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        text-shadow: none;

        .betaBadge {
            border-color: #ffffff;
        }

        .icon-container {
            position: relative;

            .red-dot {
                background: #ffafaf;
                border-radius: 5px;
                position: absolute;
                top: 6px;
                right: 8px;
                color: #495060;
                font-size: 0.667rem;
                padding: 0 4px;
            }
        }

        &:hover {
            background: #ffffff;
            color: #0071be;
            cursor: pointer;
            border-left: 6px solid #0071be30;

            .icon-container {
                .red-dot {
                    background: #ca3333;
                    color: #fff;
                }
            }

            .betaBadge {
                border-color: #0071be;
            }
        }

        &.active {
            margin-left: 0;
            border-left: 6px solid #0071be;
            border-right: none;
            background: #ffffff;
            color: #0071be;

            .icon-container {
                .red-dot {
                    background: #ca3333;
                    color: #fff;
                }
            }
        }
    }
}

.menu-logo-wrapper {
    padding: 10px;
}

@media (max-width: 991px) {
    .menu-logo-wrapper {
        padding: 10px 25px 10px;
        color: #fff;
        font-size: 24px;
        line-height: 1;
        text-align: center;
    }
}

.help-center {
    position: fixed;
    bottom: 0;
    width: 110px;
}

.isStudent {
    .left_col {
        background: #0071be;
        height: 100%;
    }

    .nav {
        &.side-menu {
            background: none;
        }
    }
}
</style>
